import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";
import Swipeable from "../../../../Fronts/Main/Swipeable";
import Grid from "@material-ui/core/Grid";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Divider from "@material-ui/core/Divider";
import { colors, Hidden, Paper, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { GetItemFromOptions } from "../../../../services/global-services";
import { useStylesLbl, useStylesTF } from "../../../../St/comps/UseStyle";
import { SharedGroupIdProvider } from "../../../Invs/BackEnd/InvoiceRest/RestProductsG";
import GroupLists from "../../../Invs/BackEnd/InvoiceRest/GroupLists";
import { GroupSelectRest } from "../../../Invs/BackEnd/POS/GroupSelectRest";
import ShiftsPermission from "./ShiftsPermission";
import { permOtherSales, permPos, permSales } from "../checksPermmision";
import DiscountsPermisson from "../DiscountsPermisson";
import CheckboxItems, { useStylesAccs } from "../CheckBoxComponents";

export default function SalesPermissions(props) {
    const { onChange, object, AutoOptions } = props;
    const typeSetting = [
        { id: 0, name: "اعدادات المبيعات", color: -1 },
        { id: 1, name: "نقاط البيع", color: -1 },
        { id: 2, name: "اعدادات الورديات", color: -1 },
        { id: 3, name: "اعدادات اخرى", color: -1 },
    ];
    const classes = useStylesAccs();
    const [saleSetting, setSaleSetting] = useState(typeSetting[0]);
    const [selectColor, setSelectColor] = useState({ id: 0, color: colors.blue[300] });
    const typSystem = [
        { id: 1, name: "تفعيل شاشة الفواتير" },
        { id: 3, name: "تقعيل شاشة المطاعم" },
        { id: 4, name: "تقعيل شاشة المحطات" },
        { id: 5, name: "تقعيل شاشة المغاسل" },
        { id: 6, name: "2تفعيل شاشة الفواتير" },
        { id: 7, name: "Plusتقعيل شاشة المطاعم" },
    ];
    const valueType = GetItemFromOptions(object?.invtype ?? 1, typSystem);
    const typePrices = [
        { id: 0, name: "التجزئة" },
        { id: 1, name: "الموزع" },
        { id: 2, name: "جملة" },
    ];
    const valuePrice = GetItemFromOptions(object?.type_sale_price ?? 1, typePrices);
    const clasTF = useStylesTF();
    const claslbl = useStylesLbl();
    const onRowClick = (row) => {
        setSaleSetting(row);
        setSelectColor({ ...row, color: colors.blue[300] });
    };
    return (
        <div className={classes.root}>
            <Accordion expanded={true}>

                <Grid item xs={12} container spacing={0} >

                    <Grid item lg={2} md={2} sm={12} xs={12}>
                        <Hidden smDown>
                            <Paper
                                style={{ minHeight: "100%", maxHeight: "100%", overflow: "auto", }}
                            >
                                <SharedGroupIdProvider>
                                    <GroupLists
                                        groups={[...typeSetting]}
                                        onRowClick={onRowClick}
                                        isMain={true}
                                        GroupColor={selectColor}
                                    />
                                    <Divider />
                                </SharedGroupIdProvider>
                            </Paper>
                        </Hidden>
                        <Hidden mdUp>
                            <GroupSelectRest
                                groups={[...typeSetting]}
                                onRowClick={onRowClick}
                                isMain={true}
                                GroupColor={selectColor}
                            />
                        </Hidden>
                    </Grid>

                    <Grid item lg={10} md={10} sm={12} xs={12}>
                        <div
                            style={{ minHeight: "100%", maxHeight: "100%", overflow: "auto", }}
                        >
                            <SharedGroupIdProvider>
                                {saleSetting.id == 0 ?
                                    <>
                                        <AccordionDetails className={classes.subTitle}>
                                        </AccordionDetails>

                                        <AccordionDetails >
                                            <Grid item container spacing={1}>
                                                {permSales
                                                    ?.filter((d) => d.visible)
                                                    ?.map((item) => {
                                                        return (
                                                            <Grid xs={6}>
                                                                <CheckboxItems
                                                                    value={object[item.name] ?? null}
                                                                    name={item.name}
                                                                    label={item.label}
                                                                    onChange={onChange}
                                                                />
                                                            </Grid>
                                                        );
                                                    })}
                                            </Grid>
                                        </AccordionDetails>
                                        <Grid container lg={12} md={12} sm={12} xs={12} spacing={1}>

                                            <Grid item lg={4} md={4} sm={6} xs={6}>
                                                <Autocomplete
                                                    value={valueType}
                                                    onChange={(event, newValue) => {
                                                        onChange(null, {
                                                            name: "invtype",
                                                            value: newValue?.id,
                                                        });
                                                    }}
                                                    id="apply_discount"
                                                    size="small"
                                                    options={typSystem}
                                                    getOptionLabel={(option) =>
                                                        typeof option === "string" ? option : option.name
                                                    }
                                                    style={{}}
                                                    disableClearable
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            InputLabelProps={{ shrink: true }}
                                                            label="نوع النظام"
                                                            variant="outlined"
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item lg={4} md={4} sm={6} xs={6}>
                                                <Autocomplete
                                                    value={valuePrice}
                                                    onChange={(event, newValue) => {
                                                        onChange(null, {
                                                            name: "type_sale_price",
                                                            value: newValue?.id,
                                                        });
                                                    }}
                                                    id="type_sale_price"
                                                    size="small"
                                                    options={typePrices}
                                                    getOptionLabel={(option) =>
                                                        typeof option === "string" ? option : option.name
                                                    }
                                                    style={{}}
                                                    disableClearable
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            InputLabelProps={{ shrink: true }}
                                                            label="سعر البيع الافتراضي"
                                                            variant="outlined"
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item lg={2} md={2} sm={5} xs={12} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                                                <TextField fullWidth variant="outlined" size="small"
                                                    id="No_Digit_Round"
                                                    label={"نسخ الطباعه"}
                                                    type="number"
                                                    className={clasTF.rootCust}
                                                    InputLabelProps={{ className: claslbl.clrBlackLblS }}
                                                    name="no_copies"
                                                    value={object.no_copies}
                                                    onChange={(event, newValue) => {
                                                        onChange(null, {
                                                            name: "no_copies",
                                                            value: event.target.value,
                                                        });
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                        <AccordionDetails>
                                            {" "}
                                            <Typography> {"إعدادات الخصومات مبيعات"}
                                            </Typography>{" "}
                                        </AccordionDetails>
                                        <AccordionDetails style={{ backgroundColor: colors.grey[50] }}>
                                            {object?.allow_discount ? <DiscountsPermisson {...props} /> :
                                                <Typography variant="h5" style={{ textAlign: "center" }}>
                                                    {"\n تاكد من تفعيل السماح بالخصم حتى يتم تفعيل الخيارات"}

                                                </Typography>}
                                        </AccordionDetails>
                                        <Divider className={classes.divider} />
                                    </>
                                    : saleSetting.id == 1 ?

                                        <AccordionDetails >
                                            <Grid item container spacing={1}>
                                                {permPos
                                                    ?.filter((d) => d.visible)
                                                    ?.map((item) => {
                                                        return (
                                                            <Grid xs={6}>
                                                                <CheckboxItems
                                                                    value={object[item.name] ?? null}
                                                                    name={item.name}
                                                                    label={item.label}
                                                                    onChange={onChange}
                                                                />
                                                            </Grid>
                                                        );
                                                    })}
                                            </Grid>
                                        </AccordionDetails>
                                        : saleSetting.id == 2 ?
                                            <ShiftsPermission   {...{ onChange, object, accounts:AutoOptions.Accindex }} />
                                            : <AccordionDetails >
                                                <Grid item container spacing={1}>
                                                    {permOtherSales
                                                        ?.filter((d) => d.visible)
                                                        ?.map((item) => {
                                                            return (
                                                                <Grid xs={6}>
                                                                    <CheckboxItems
                                                                        value={object[item.name] ?? null}
                                                                        name={item.name}
                                                                        label={item.label}
                                                                        onChange={onChange}
                                                                    />
                                                                </Grid>
                                                            );
                                                        })}
                                                </Grid>
                                            </AccordionDetails>
                                }

                            </SharedGroupIdProvider>
                        </div>
                    </Grid>
                </Grid>
            </Accordion>
            <Swipeable />
        </div>
    );
}
